/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';


export interface SearchManufacturersDictionaryRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
}

